import React from 'react';
import { isInTrialBillingPeriod } from './planRules';

interface CostBreakdownProps {
	planName: string;
	planPrice: number;
	includedSeats: number;
	additionalSeats: number;
	seatPrice: number;
	totalPrice: number;
	formattedBillingDate?: string;
	isNewLineup: boolean;
}

const CostBreakdown = ({
	planName,
	planPrice,
	includedSeats,
	additionalSeats,
	seatPrice,
	totalPrice,
	formattedBillingDate = '',
	isNewLineup,
}: CostBreakdownProps) => {
	const showSeats = isNewLineup;
	const totalLabel =
		isInTrialBillingPeriod() && formattedBillingDate
			? `Billed on ${formattedBillingDate}`
			: 'Monthly Total';
	return (
		<div className="cost-breakdown">
			<div className="cost-breakdown__section">
				<div className="cost-breakdown__section-label">Plan</div>
				<div className="cost-breakdown__line cost-breakdown__line--two-col">
					<span>{planName}</span>
					<span>${planPrice.toFixed(2)}</span>
				</div>
			</div>
			{showSeats && (
				<div className="cost-breakdown__section">
					<div className="cost-breakdown__section-label">Users</div>
					<div className="cost-breakdown__line cost-breakdown__line--stacked">
						<div className="cost-breakdown__line-label">
							<span>Included in Plan</span>
							<span className="cost-breakdown__line-rate">
								$0.00/mo x {includedSeats}{' '}
								{includedSeats === 1 ? 'seat' : 'seats'}
							</span>
						</div>
						<span className="cost-breakdown__line-price">$0.00</span>
					</div>
					{additionalSeats > 0 && (
						<div className="cost-breakdown__line cost-breakdown__line--stacked">
							<div className="cost-breakdown__line-label">
								<span>Additional Users</span>
								<span className="cost-breakdown__line-rate">
									${seatPrice.toFixed(2)}/mo x {additionalSeats}{' '}
									{additionalSeats === 1 ? 'seat' : 'seats'}
								</span>
							</div>
							<span className="cost-breakdown__line-price">
								${(additionalSeats * seatPrice).toFixed(2)}
							</span>
						</div>
					)}
				</div>
			)}
			{showSeats && (
				<div className="cost-breakdown__total">
					<span>{totalLabel}</span>
					<span>${totalPrice.toFixed(2)}</span>
				</div>
			)}
		</div>
	);
};

export default CostBreakdown;
